export default function currencyFormatting(
  value?: number | null,
  returnFree = true,
  currency = 'USD',
  locales = 'en-US',
) {
  if (!value && value !== 0) return undefined;

  if (returnFree && value === 0) return 'FREE';

  return new Intl.NumberFormat(locales, {
    currency,
    style: 'currency',
    useGrouping: true,
  }).format(value);
}
